import { useLanguage } from 'context/language.context';
import { ToastContainer } from 'react-toastify';
import { Router } from 'router';

function App() {
  const { direction } = useLanguage();
  return (
    <div
      id="App"
      dir={direction}
      style={{ fontFamily: direction === 'rtl' ? 'TheSansArab, sans-serif' : 'Inter, sans-serif' }}
    >
      <Router />
      <ToastContainer
        position={direction === 'rtl' ? 'bottom-left' : 'bottom-right'}
        closeButton={false}
        hideProgressBar={true}
        className={'gap-1 mb-4 xs:mb-0'}
      />
    </div>
  );
}

export default App;
